import axios from "../../common"

export const ApiListGroups = async () => {
    return axios.get("/auth/groups/list/", {withCredentials: true})
}

export const ApiDeleteGroup = async (id: number) => {
    return axios.delete( `/auth/groups/detail/${id}/`, {withCredentials: true} )
}

export const ApiEnableGroup = async (id: number) => {
    return axios.put( `/auth/groups/detail/${id}/`, {is_active: true}, {withCredentials: true} )
}

export const ApiUpdateGroup = async (id: number, data: any) => {
    return axios.put( `/auth/groups/detail/${id}/`, data, {withCredentials: true} )
}

export const ApiCreateGroup = async (data: any) => {
    return axios.post( `/auth/groups/create/`, data, {withCredentials: true} )
}